import { Component, OnInit, ElementRef, Output, EventEmitter } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { NewRequestService } from 'app/shared/new-request.service';
import { GraphService } from 'app/shared/graph.service';
import { AuthService } from 'app/shared/auth.service';
import { AdministratorService } from 'app/administrator/administrator.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  host: {
    '(window:click)': 'onClick()',
  },
})
export class NavbarComponent implements OnInit {
  private listTitles: any[];
  location: Location;
  mobile_menu_visible: any = 0;
  private toggleButton: any;
  private sidebarVisible: boolean;
  public showButton: boolean;
  public requestId: any;
  public clientName: boolean;
  public width_nav: string;
  public userName: string;
  public showSignout: boolean;

  @Output() showMenuToggle = new EventEmitter<string>();
  constructor(
    location: Location,
    private element: ElementRef,
    private router: Router,
    private readonly newRequestService: NewRequestService,
    private readonly administratorService: AdministratorService,
    private readonly graphService: GraphService,
    private readonly authService: AuthService,
    private toastr: ToastrService
  ) {
    this.location = location;
    this.sidebarVisible = false;
  }

  ngOnInit() {
    this.showSignout = false;
    if (!!this.graphService.currentUser) {
      this.userName = this.graphService.currentUser.givenName;
    } else {
      this.graphService.getCurrentUser().then((data) => {
        this.userName = data.givenName;
      });
    }

    this.listTitles = ROUTES.filter((listTitle) => listTitle);
    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];

    this.newRequestService.requestForm$.subscribe((data) => {
      if (!!data && !!data.requestId && data.requestId > 0) {
        this.requestId = data.requestId;
        this.clientName = data.clientName;
      } else {
        this.requestId = this.clientName = null;
      }
    });

    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)) {
      this.showButton = true;
    } else {
      this.showButton = false;
    }
  }

  openMenu($event) {
    $event.stopPropagation();
    this.showSignout = !this.showSignout;
  }

  onClick() {
    this.showSignout = false;
  }

  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const body = document.getElementsByTagName('body')[0];
    setTimeout(function () {
      toggleButton.classList.add('toggled');
    }, 500);

    body.classList.add('nav-open');

    this.sidebarVisible = true;
  }

  closeNav() {
    this.showButton = !this.showButton;
    this.width_nav = 'nav_width_0';
    const regex_mobile = new RegExp(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/, 'i');
    if (regex_mobile.test(window.navigator.userAgent)) {
      this.showButton ? document.getElementById("overlay").style.display = "none" : document.getElementById("overlay").style.display = "block";
      this.showButton ? this.showMenuToggle.emit('showMenu') : this.showMenuToggle.emit('hideMenu');
    }
    document.getElementById('layout-sidebar-close').style.display = 'none';
    document.getElementById('mainPage').classList.add('toggledWidth');
  }

  openNav() {
    this.showButton = !this.showButton;
    this.width_nav = '';
    const regex_mobile = new RegExp(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/, 'i');
    if (regex_mobile.test(window.navigator.userAgent)) {
      this.showButton ? document.getElementById("overlay").style.display = "none" : document.getElementById("overlay").style.display = "block";
      this.showButton ? this.showMenuToggle.emit('showMenu') : this.showMenuToggle.emit('hideMenu');
    }
    document.getElementById('layout-sidebar-close').style.display = 'initial';
    document.getElementById('mainPage').classList.remove('toggledWidth');
  }

  mobileCloseNav() {
    this.showButton = !this.showButton;
    const regex_mobile = new RegExp(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/, 'i');
    if (regex_mobile.test(window.navigator.userAgent)) {
      this.showButton ? document.getElementById("overlay").style.display = "none" : document.getElementById("overlay").style.display = "block";
      this.showButton ? this.showMenuToggle.emit('showMenu') : this.showMenuToggle.emit('hideMenu');
    }
    document.getElementById('layout-sidebar-close').style.display = 'none';
  }

  mobileOpenNav() {
    this.showButton = !this.showButton;
    const regex_mobile = new RegExp(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/, 'i');
    if (regex_mobile.test(window.navigator.userAgent)) {
      this.showButton ? document.getElementById("overlay").style.display = "none" : document.getElementById("overlay").style.display = "block";
      this.showButton ? this.showMenuToggle.emit('showMenu') : this.showMenuToggle.emit('hideMenu');
    }
    document.getElementById('layout-sidebar-close').style.display = 'initial';
  }

  public logOut() {
    // this.administratorService.getData('Logout');
    this.authService.logOut();
  }

  createDuplicateRequest() {
    let data = { "RequestID": parseInt(this.requestId) };
    let response;
    this.administratorService.postData(data, "DuplicateRequests").then((data: any) => {
      if (data.length > 0) {
        this.toastr.success('Duplicate request created successfully.');
        window.open("#/new-request?RequestID=" + data[0].RequestID);
      } else {
        this.toastr.error('Some error has occurred.');
      }
    });
  }
}
